// **********************************************************
// Category Toggle
// **********************************************************

attachEvent('.product-filter__category--link', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-filter__category');
  const mainParent = parentEle.closest('.product-filter');
  mainParent
    .querySelectorAll('.product-filter__category--link.is-active')
    .forEach((category) => category.classList.remove('is-active'));
  parentEle.classList.add('is-active');
});

// **********************************************************
// Add/Remove/Clear Filters
// **********************************************************

const selectedItems = document.querySelectorAll('.product-filter__selected-list');
const selectedItemsParent = document.querySelectorAll('.product-filter__row--selected-items');
const allFilterInputs = document.querySelectorAll('.product-filter__filter input, .filter-modal input');

const toggleFilterParent = (toggle) => {
  selectedItemsParent.forEach((item) => {
    toggleHideClass(item, toggle);
  });
};

const checkSelectedItems = () => {
  selectedItems.forEach((item) => {
    const remainingItems = item.querySelectorAll('.filter-modal, .product-filter__selected');
    if (remainingItems.length === 0) toggleFilterParent(true);
  });
};

const removeSelectedFilter = (id) => {
  document.querySelectorAll(`[data-filter-id="${id}"]`).forEach((item) => item.remove());
  checkSelectedItems();
};

const removeSelectedFiltersByName = (name) => {
  document.querySelectorAll(`.product-filter__selected[data-filter-name="${name}"]`).forEach((btn) => btn.remove());
};

const addSelectedFilter = (text, id, name) => {
  if (!id.toLowerCase().startsWith('filter-modal-')) {
    const prepareSelectedItemElem = `<button class="product-filter__selected text--12" type="button" data-filter-id="${id}" data-filter-name="${name}"><i class="icon icon-close"></i><span class="p-none">${text}</span></button>`;

    selectedItems.forEach((container) => {
      const resetWrapper = container.querySelector('.product-filter__reset-btn-wrapper');
      if (resetWrapper) {
        resetWrapper.insertAdjacentHTML('beforebegin', prepareSelectedItemElem);
      } else {
        container.insertAdjacentHTML('beforeend', prepareSelectedItemElem);
      }
    });

    toggleFilterParent(false);
  }
};

// Uncheck Filters
const unCheckFilterInputs = (id) => {
  document.querySelectorAll(`#${id}`).forEach((input) => {
    const dropdown = input.closest('.dropdown');
    input.checked = false;
    if (dropdown) countSelected(dropdown);
  });
};

// Check/Uncheck Filters On Change

const applyFilterState = (input) => {
  const inputText = input.getAttribute('data-text');
  const inputId = input.getAttribute('id');
  const inputName = input.getAttribute('name');

  if (input.type === 'radio') {
    if (input.checked) {
      removeSelectedFiltersByName(inputName);
      addSelectedFilter(inputText, inputId, inputName);
    }
    return;
  }

  if (input.checked) {
    addSelectedFilter(inputText, inputId, inputName);
  } else {
    removeSelectedFilter(inputId);
  }
};

const triggerFilter = (input) => {
  input.addEventListener('change', () => {
    applyFilterState(input);
    Promise.resolve().then(() => {
      countSelected(input.closest('.dropdown'));
    });
  });
};

// Filter
allFilterInputs.forEach((input) => {
  triggerFilter(input);
  applyFilterState(input); // With Page Load
});

// Remove Selected Item
attachEvent('.product-filter__selected', 'click', (ev) => {
  const selectedEle = ev.target.closest('.product-filter__selected');
  const inputId = ev.target.getAttribute('data-filter-id');
  const modalCheck = document.getElementById(inputId.replace('filter-', 'filter-modal-'));
  modalCheck.checked = false;
  const dropdown = modalCheck.closest('.dropdown');
  if (dropdown) {
    countSelected(dropdown);
  }

  selectedEle.remove();
  unCheckFilterInputs(inputId);
  checkSelectedItems();
});

// Clear all filter
attachEvent('[data-reset-filter]', 'click', (ev) => {
  document.querySelectorAll('.filter-modal .dropdown__list-item input').forEach((item) => {
    item.checked = false;
  });
  document.querySelectorAll('.dropdown-accordion .dropdown__count').forEach((item) => {
    item.classList.add('hide');
  });

  document.querySelectorAll('.product-filter__selected').forEach((item) => {
    const inputId = item.getAttribute('data-filter-id');
    unCheckFilterInputs(inputId);
    item.remove();
  });

  document.querySelectorAll('.product-filter__filter .dropdown').forEach(countSelected);

  checkSelectedItems();

  // Sort Reset
  document.querySelectorAll('.sort-dropdown input').forEach((input) => (input.checked = false));

  ev.preventDefault();
});

// Toggle Dropdown Into Mobile
const toggleFilterDrawer = (parent, toggle) => {
  const filterEle = parent.querySelector('.product-filter__filter');
  filterEle.classList.toggle('is-open-filter', toggle);
  toggleBodyScrollLock(toggle);
};

const closeFilterDropdown = (parent) => {
  parent.querySelectorAll('[data-dropdown].is-active').forEach((dropdown) => dropdown.classList.remove('is-active'));
  toggleFilterDrawer(parent, false);
};

// Open Filter
attachEvent('[data-target-dropdown]', 'click', (ev) => {
  ev.stopPropagation();
  const parentEle = ev.target.closest('.product-filter');
  const targetDropdown = ev.target.getAttribute('data-target-dropdown');
  const dropdownEle = parentEle?.querySelector(`[data-dropdown="${targetDropdown}"]`);

  closeFilterDropdown(parentEle);

  dropdownEle.classList.add('is-active');
  toggleFilterDrawer(parentEle, true);
});

// Close Dropdown
attachEvent('[data-close-filter], [data-dropdown] .dropdown__placeholder', 'click', (ev) => {
  const parentEle = ev.target.closest('.product-filter');
  closeFilterDropdown(parentEle);
});
